<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/tenderDocument/add')">新增</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">
        <!-- <el-form-item label="采购类型" prop="purchaseType">
          <el-select v-model="searchForm.purchaseType" clearable @change="changeType" filterable placeholder="请选择采购类型">
            <el-option v-for="(item, index) of typeArr" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格" prop="specId">
          <el-select v-model="searchForm.specId" clearable filterable
            :placeholder="searchForm.purchaseType ? '请选择规格' : '请先选择采购类型'"
            :disabled="searchForm.purchaseType ? false : true">
            <el-option v-for="(item, index) of specList"
              :value="searchForm.purchaseType == '1' ? item.specId : item.materialId"
              :label="searchForm.purchaseType == '1' ? item.specName : item.materialName" :key="index"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item prop="bidStart" label="招标开始日期">
          <el-date-picker v-model="searchForm.bidStart" placeholder="请选择招标开始日期" type="date" clearable
            format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="bidEnd" label="招标截至日期">
          <el-date-picker v-model="searchForm.bidEnd" placeholder="请选择招标截至日期" type="date" clearable format="yyyy-MM-dd"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="searchForm.status" clearable filterable placeholder="请选择状态">
            <el-option v-for="(item, index) of statusArr" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <!-- <div class="flex-end">
        <span>招标中数量:<span class="num">{{ countInfo.documentNum || 0 }}</span></span>
        <span>待发货数量:<span class="num"> {{ countInfo.deliveryNum || 0 }}</span></span>
        <span>待开发票数量:<span class="num"> {{ countInfo.invoiceNum || 0 }}</span></span>
      </div> -->
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="标书ID" prop="bidId"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="标题" prop="bidTitle"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="采购方" prop="purchaserName"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip min-width="100" label="规格" prop="specName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="采购类型" prop="purchaseType">
          <template v-slot="{ row }">
            <span v-if="row.purchaseType == '1'">粮油</span>
            <span v-if="row.purchaseType == '2'">物料</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" label="订单数量" prop="purchaseQuantity"></el-table-column> -->
        <el-table-column show-overflow-tooltip min-width="140" label="招标开始日期" prop="bidStart"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" label="招标截至日期" prop="bidEnd"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" label="状态" prop="status">
          <template v-slot="{ row }">
            <!-- 1招标中2评标中3已中标4已废标 -->
            <el-tag v-if="row.status == '1'">招标中</el-tag>
            <el-tag v-if="row.status == '2'">评标中</el-tag>
            <el-tag type="success" v-if="row.status == '3'">已中标</el-tag>
            <el-tag type="danger" v-if="row.status == '4'">已废标</el-tag>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="190">
          <template v-slot="{ row }">
            <el-button type="text" v-if="hasEdit && ['1', '2'].includes(row.status)"
              @click="$router.push('/tenderDocument/edit?bidId=' + row.bidId)">编辑</el-button>
            <el-button type="text" v-if="['1', '2'].includes(row.status)" @click="onUnBind(row)">废标</el-button>
            <el-button type="text" @click="$router.push('/tenderDocument/detail?bidId=' + row.bidId)">详情</el-button>
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.bidId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'TenderDocument',

  data () {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        purchaseType: null,
        bidStart: null,
        bidEnd: null,
        status: null,
        specId: null

      },
      specList: [],
      // 1粮油2物料
      typeArr: [
        {
          label: '粮油',
          value: '1'
        },
        {
          label: '物料',
          value: '2'
        }
      ],
      // 1招标中2评标中3已中标4已废标
      statusArr: [
        {
          label: '招标中',
          value: '1'
        },
        {
          label: '评标中',
          value: '2'
        },
        {
          label: '已中标',
          value: '3'
        },
        {
          label: '已废标',
          value: '4'
        }
      ],
      countInfo: {
        documentNum: 0,
        deliveryNum: 0,
        invoiceNum: 0

      }

    }
  },
  computed: {

    buttonList () {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd () {
      return this.buttonList.includes('add')
    },
    hasEdit () {
      return this.buttonList.includes('edit')
    },
    hasAbandon () { // 废标
      return this.buttonList.includes('abandon')
    },
    hasWinTheBid () { // 中标
      return this.buttonList.includes('winTheBid')
    },
    hasDel () {
      return this.buttonList.includes('delete')
    }
  },
  created () {
    this.loadData()
    // this.loadCount()
  },
  methods: {
    changeType (val) {
      this.searchForm.specId = ''
      this.specList = []
      if (val === '1') { // 粮油规格
        this.getSpec()
      }
      if (val === '2') { // 物料
        this.getWl()
      }
    },
    getSpec () {
      this.$axios
        .get(this.$apis.grainSpecifications.selectYxOilSpecByList)
        .then(res => {
          this.specList = res.list || []
        })
    },
    getWl () {
      this.$axios.get(this.$apis.materialsManage.selectYcMaterialByPage
      ).then(res => {
        this.specList = res.list || []
      })
    },
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.tenderDocument.selectYcBidDocumentByPage, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    loadCount () {
      this.$axios.get(this.$apis.tenderDocument.selectYcBidDocumentCount, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.countInfo = res || {}
      })
    },

    onSearch () {
      this.page = 1
      this.loadData()
    },
    resetForm () {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        purchaseType: null,
        bidStart: null,
        bidEnd: null,
        status: null,
        specId: null

      }
      this.onSearch()
    },
    onUnBind (row) {
      this.$confirm('确认废标该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.tenderDocument.addYcBidDocument, {
          bidId: row.bidId,
          relId: row.relId,
          supplierId: ''
        }).then(() => {
          this.loadData()
        })
      })
    },
    deleteRow (bidId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.tenderDocument.deleteYcBidDocument, {
          bidId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;

  .num {
    color: #007bff;
    margin-right: 15px;

  }
}
</style>
